// noinspection JSUnusedGlobalSymbols,JSUnresolvedReference

export class _History {
    constructor({id, instance, status, timestamp}) {
        this.id = id;
        this.instance = instance;
        this.status = status;
        this.timestamp = timestamp;
    };

    clone() {
        return new _History({
            id: this.id,
            instance: this.instance,
            status: this.status,
            timestamp: this.timestamp
        });
    };
};

export const historyConverter = {
    toFirestore(history) {
        return {
            instance: history.instance,
            status: history.status,
            timestamp: history.timestamp
        };
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return new _History({
            id: snapshot.id,
            instance: data.instance,
            status: data.status,
            timestamp: data.timestamp
        });
    }
};